import { f7 } from 'framework7-react';
import { useCallback, useMemo } from 'react';
import {
  CarConditionEntryItemType,
  CheckInReserveDataType,
  CheckInReserveInfoType,
} from '../../../types/bodyAndPaint';
import { CheckInCarCondition } from './carConditionEntry/checkInCarCondition';
import { useCarConditionState } from './hook/state/useCarConditionState';
import { useStorageItem } from './hook/useStorageItem';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';
import { store } from '@/config/store';

export const CheckInCarConditionPage = () => {
  const { stored: checkInEntries, setStorageItem: setCheckInEntries } =
    useStorageItem<CheckInReserveDataType>({ key: 'checkInReserve' });

  const reserveInfo: CheckInReserveInfoType = useMemo(() => {
    const { authInfo, customerInfo, carItemInfo } = store.state;
    return {
      ids: {
        customerID: authInfo?.m_customer_id ?? 0,
        affiliateID: customerInfo?.m_affiliate_id ?? 0,
        stockCarID: carItemInfo?.t_stock_car_id ?? 0,
        unitID: customerInfo?.m_unit_id ?? 0,
        unitName: customerInfo?.unit_name ?? '',
        plantID: checkInEntries?.reserveInfo?.ids?.plantID ?? 0,
      },
      carName: carItemInfo?.car_nm ?? '',
      category: carItemInfo?.maker_nm ?? '',
      factoryName: checkInEntries?.reserveInfo?.factoryName ?? '',
      factoryMapAddress: checkInEntries?.reserveInfo?.factoryMapAddress ?? '',
      factoryPhoneNumber: checkInEntries?.reserveInfo?.factoryPhoneNumber ?? '',
    };
  }, [checkInEntries]);

  const initialCarCondition = useMemo(
    () => checkInEntries?.carConditionInfo ?? ({} as CarConditionEntryItemType),
    [checkInEntries?.carConditionInfo],
  );

  const {
    state: carConditionState,
    setState: carConditionSetState,
    list: carConditionList,
    error: carConditionError,
    pickerInfo,
    disabled,
  } = useCarConditionState({
    initial: initialCarCondition,
  });

  const handleClickBack = () => {
    setCheckInEntries({
      carConditionInfo: {},
      insuranceInfo: {},
      checkInDateInfo: {},
      loanerCarInfo: {},
    } as CheckInReserveDataType);
    f7.views.main.router.navigate(paths.maintenance);
  };
  const handleClickNext = useCallback(() => {
    setCheckInEntries((prev) => ({
      ...prev,
      reserveInfo: reserveInfo,
      carConditionInfo: carConditionState,
    }));
    f7.views.main.router.navigate(paths.bpsCheckInUseInsurance);
  }, [reserveInfo, carConditionState, setCheckInEntries]);

  return (
    <PageTemplateComponent
      pageName={'checkInReserve'}
      title={'傷・凹み修理予約'}
      onBack={handleClickBack}
    >
      <CheckInCarCondition
        state={carConditionState}
        setState={carConditionSetState}
        list={carConditionList}
        error={carConditionError}
        pickerInfo={pickerInfo}
        disabled={disabled}
        onNext={handleClickNext}
      />
    </PageTemplateComponent>
  );
};
